import {
  ProductSingleProps,
  ProductSingleVariationProps
} from "../../../queries/archive";

export const getStockQuantity = (
  filteredVariations: ProductSingleVariationProps[],
  product?: ProductSingleProps
) => {
  const availableStock = filteredVariations.length === 1 ? filteredVariations[0].node?.stockQuantity : product?.stockQuantity; // prettier-ignore
  return availableStock || 0;
};
